import { Indicator } from './dropdownIndicator.styles';

export const DropdownIndicator = ({ ...props }) => (
  <Indicator isMenuOpen={props.selectProps.menuIsOpen} />
);
